import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import * as validationRulesServices from "../service/ValidationRules"
import { ValidationOutcome } from "../api/generated/models/ValidationOutcome"
import { OpCoValidationRuleRead } from "../api/generated"
import useShowError from "./useShowError"

const VALIDATION_RULES = "validation_rules"
const VALIDATION_CONFIG_RULES = "validation_config_rules"

export const useValidationRules = () =>
  useQuery({
    queryKey: [VALIDATION_RULES],
    queryFn: () => validationRulesServices.getAllOpCoValidationRules(),
    placeholderData: [],
  })

export const useOpcoValidationConfigRules = () =>
  useQuery({
    queryKey: [VALIDATION_CONFIG_RULES],
    queryFn: () => validationRulesServices.getAllOpCoValidationConfigSettings(),
    placeholderData: [],
  })

export const useDownloadValidationConfigTemplate = () => {
  return useMutation({
    mutationFn: ({ validationId, opcoId }: { validationId: number, opcoId: number }) => validationRulesServices.downloadTemplateForValidationRule(opcoId,validationId),
  })
}


export const useUpdateValidationRule = () => {
  const queryClient = useQueryClient()
  const showError = useShowError()

  return useMutation({
    mutationFn: ({
      ruleId,
      outcome,
      status
    }: {
      ruleId: number
      outcome: ValidationOutcome
      status?: boolean
    }) => {
      return validationRulesServices.updateOpCoValidationRuleOutcome(ruleId, {
        outcome,
        is_enable: status
      })
    },
    onSuccess: (response) => {
      queryClient.setQueryData(
        [VALIDATION_RULES],
        (old: Array<OpCoValidationRuleRead>) =>
          old.map((item) => (item.id === response.id ? response : item)),
      );
      queryClient.invalidateQueries({queryKey: [VALIDATION_CONFIG_RULES]});
    },
    onError(error) {
      showError(`Failed to update validation rule: ${error.message}`)
    },
  })
}
